import React, { useEffect, useRef } from 'react'
import { useSpeechStore } from '../Contexts/SpeechContext'
import { useRetorikStore } from '../Contexts/RetorikContext'
import { useUtilsStore } from '../Contexts/UtilsContext'
import { useViewStore } from '../Contexts/ViewContext'
import { useDirectlineStore } from '../Contexts/DirectlineContext'
import { CurrentSubView, ListStatus, RecognitionState, RetorikEvent, Routes } from '../../models/enums'

interface SendTypingIndicatorProps {
  isRetorikNews: boolean
}

const typingTimer = 2000

const SendTypingIndicator = ({ isRetorikNews }: SendTypingIndicatorProps): JSX.Element => {
  const speaking = useSpeechStore((state) => state.speaking)
  const streamingQueue = useSpeechStore((state) => state.streamingQueue)
  const activeRecognitionState = useSpeechStore((state) => state.activeRecognitionState)
  const route = useViewStore((state) => state.route)
  const loaderClosed = useRetorikStore((state) => state.loaderClosed)
  const appAvailable = useRetorikStore((state) => state.appAvailable)
  const isWaitingForResponse = useRetorikStore((state) => state.isWaitingForResponse)
  const currentSubView = useUtilsStore((state) => state.currentSubView)
  const listStatus = useUtilsStore((state) => state.listStatus)
  const retorikEvent = useUtilsStore((state) => state.retorikEvent)
  const userIsTyping = useUtilsStore((state) => state.userIsTyping)
  const userIsSwiping = useUtilsStore((state) => state.userIsSwiping)
  const sendTyping = useDirectlineStore((state) => state.actions.sendTyping)

  const dataRef = useRef<boolean | null>(false)

  useEffect(() => {
    // Don't send typing activity when we are receiving streaming events
    const isReceivingStreamingData =
      !!streamingQueue.length &&
      !!streamingQueue.find((activity) => activity.name?.toLowerCase() === 'davi.streammessageactivity') &&
      !streamingQueue.find((activity) => activity.value?.streamingCount)

    dataRef.current =
      !isWaitingForResponse &&
      // Don't send typing activity when we are receiving streaming events
      !isReceivingStreamingData &&
      (!loaderClosed ||
        activeRecognitionState !== RecognitionState.Closed ||
        userIsTyping ||
        userIsSwiping ||
        speaking ||
        currentSubView !== CurrentSubView.none ||
        route === Routes.News ||
        retorikEvent === RetorikEvent.DetailViewOpen ||
        listStatus === ListStatus.opened)
  }, [appAvailable, loaderClosed, activeRecognitionState, userIsTyping, userIsSwiping, speaking, streamingQueue, currentSubView, route, retorikEvent, listStatus, isWaitingForResponse])

  const checkShouldSendTypingIndicator = (): void => {
    dataRef.current && !isRetorikNews && sendTyping()
  }

  useEffect(() => {
    const interval = setInterval(() => {
      checkShouldSendTypingIndicator()
    }, typingTimer)

    return () => {
      interval && clearInterval(interval)
    }
  }, [])

  return <React.Fragment />
}

export default SendTypingIndicator
